import { render, staticRenderFns } from "./Bookings_ModalPax.vue?vue&type=template&id=88a57546&"
import script from "./Bookings_ModalPax.vue?vue&type=script&lang=js&"
export * from "./Bookings_ModalPax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports